module.exports = __webpack_public_path__ + "assets/fonts/GothamRnd-LightIta.35bdba4f.otf";